// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.achcw5WQLyYjE8hD{max-width:1100px}.achcw5WQLyYjE8hD .eGUkZBYchgsYKgAF{display:flex;justify-content:space-between}.achcw5WQLyYjE8hD .eGUkZBYchgsYKgAF .OvjYGU5voiIfsh5n{width:328px}.achcw5WQLyYjE8hD .eGUkZBYchgsYKgAF .sZIuINfmSu0lN5mM{display:flex}.achcw5WQLyYjE8hD .eGUkZBYchgsYKgAF .sZIuINfmSu0lN5mM .Wc5AMwXzJQva6Rpd{display:flex;align-items:center;height:32px;gap:8px;margin-right:8px;label-text-wrap:nowrap}.achcw5WQLyYjE8hD .eGUkZBYchgsYKgAF .sZIuINfmSu0lN5mM .Wc5AMwXzJQva6Rpd .hZatcuutuYA63LYf{width:150px;height:32px}.achcw5WQLyYjE8hD .QMXL8Q7OacEGZCek{width:100%;min-width:1000px}.achcw5WQLyYjE8hD .XdGL4rRSWzEW_dzv{display:flex;flex-direction:column;align-items:center}.DPBgd3bfaoWKOJCL{display:grid;grid-column-gap:4px;grid-template-columns:20px 1fr;align-items:center}.KIiIynu1gKAsDcKj{text-align:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `achcw5WQLyYjE8hD`,
	"tableControls": `eGUkZBYchgsYKgAF`,
	"search": `OvjYGU5voiIfsh5n`,
	"headerRight": `sZIuINfmSu0lN5mM`,
	"factorFilter": `Wc5AMwXzJQva6Rpd`,
	"select": `hZatcuutuYA63LYf`,
	"table": `QMXL8Q7OacEGZCek`,
	"emptyState": `XdGL4rRSWzEW_dzv`,
	"userBox": `DPBgd3bfaoWKOJCL`,
	"maxQuestionsModal": `KIiIynu1gKAsDcKj`
};
export default ___CSS_LOADER_EXPORT___;
